import { useQuery, gql } from "@apollo/client";
import { StorageHelper } from "../utils/storageHelper";
import { useEffect } from "react";

export const GET_SCHEMA_DOMAIN = gql`
  query GetSchemaDomain($hostname: String!) {
    GetSchemaDomain(hostname: $hostname) {
      org_id
      hostname
      schema_name
      is_active
      org_name
      status_id
    }
  }
`;

export const useSchemaDomain = () => {
  const hostname = window.location.hostname;
  const cachedSchema = StorageHelper.get("schemaInfo");
  const token = StorageHelper.get("token");

  const { data, loading, error, refetch } = useQuery(GET_SCHEMA_DOMAIN, {
    variables: { hostname },
    fetchPolicy: "network-only",
    skip: !token, // Skip the query if no token is available
    onCompleted: (data) => {
      if (data?.GetSchemaDomain) {
        StorageHelper.set("schemaInfo", data.GetSchemaDomain);
      }
    },
    onError: (error) => {
      console.error("Schema query error:", error);
    },
  });

  const schemaInfo = data?.GetSchemaDomain || cachedSchema;

  // Retry logic if query fails and we have a token
  useEffect(() => {
    let retryCount = 0;
    const maxRetries = 3;
    const retryInterval = 2000;

    const retryFetch = async () => {
      if (token && error && retryCount < maxRetries && !schemaInfo) {
        retryCount++;
        console.log(`Retrying schema fetch attempt ${retryCount}`);

        setTimeout(async () => {
          try {
            await refetch();
          } catch (err) {
            if (retryCount < maxRetries) {
              retryFetch();
            }
          }
        }, retryInterval * retryCount);
      }
    };

    retryFetch();
  }, [error, refetch, schemaInfo, token]);

  return {
    schemaInfo,
    loading: loading && !schemaInfo && !!token,
    error: token ? error : null,
    refetch,
  };
};
